import { useMatrix } from '@/core/domain/enterprise/Matrix/Matrix.hooks';
import { ListStockItemsQuery } from '@/core/domain/stock/StockItems/StockItems.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { RegistrationsDefaultCode } from '@/types/Register';
import { licensePlateMask } from '@/utils/mask/commonMasks';
import { Col, Input, Row } from 'antd';
import { useIntl } from 'react-intl';
import MaskedInput from 'react-text-mask';

interface Props {
  isPartOs?: boolean;
  setQueryParams: React.Dispatch<React.SetStateAction<ListStockItemsQuery>>;
}

export default function QuotationPartsExtraFilters({
  isPartOs = false,
  queryParams,
  setQueryParams,
}: Props & ExtraFiltersProps<ListStockItemsQuery>) {
  const intl = useIntl();

  const { data } = useMatrix();

  return (
    <Row gutter={[16, 16]}>
      {isPartOs && (
        <Col span={24} sm={12} lg={6}>
          <Input
            onChange={({ target: { value } }) =>
              setQueryParams((prev) => ({
                ...prev,
                workOrderFilter: value
                  ? Number(value.split('/')[0]).toString()
                  : undefined,
              }))
            }
            placeholder="Orçamento"
          />
        </Col>
      )}

      {isPartOs && (
        <Col span={24} sm={12} lg={6}>
          <MaskedInput
            guide={false}
            name="licensePlate"
            className="ant-input"
            mask={licensePlateMask}
            onChange={({ target: { value } }) =>
              setQueryParams((prev) => ({
                ...prev,
                licensePlateFilter: value.toUpperCase(),
              }))
            }
            placeholder="Placa"
          />
        </Col>
      )}

      {data?.matrixSettings.defaultPartCode ===
        RegistrationsDefaultCode.barCode && (
        <Col span={24} sm={12} lg={6}>
          <Input
            value={queryParams?.barcode}
            onChange={({ target: { value } }) =>
              setQueryParams((prev) => ({ ...prev, barcode: value }))
            }
            placeholder={intl.formatMessage({ id: 'parts.entity.barCode' })}
          />
        </Col>
      )}

      {data?.matrixSettings.defaultPartCode ===
        RegistrationsDefaultCode.internalCode && (
        <Col span={24} sm={12} lg={6}>
          <Input
            value={queryParams?.originalCode}
            onChange={({ target: { value } }) =>
              setQueryParams((prev) => ({ ...prev, sku: value }))
            }
            placeholder={intl.formatMessage({
              id: 'parts.entity.originalCode',
            })}
          />
        </Col>
      )}

      {data?.matrixSettings.defaultPartCode ===
        RegistrationsDefaultCode.manufacturerCode && (
        <Col span={24} sm={12} lg={6}>
          <Input
            value={queryParams?.manufacturingCode}
            onChange={({ target: { value } }) =>
              setQueryParams((prev) => ({ ...prev, manufacturingCode: value }))
            }
            placeholder={intl.formatMessage({
              id: 'parts.entity.manufacturerCode',
            })}
          />
        </Col>
      )}

      {data?.matrixSettings.defaultPartCode ===
        RegistrationsDefaultCode.companyCode && (
        <Col span={24} sm={12} lg={6}>
          <Input
            value={queryParams?.companyCode}
            onChange={({ target: { value } }) =>
              setQueryParams((prev) => ({ ...prev, companyCode: value }))
            }
            placeholder={intl.formatMessage({
              id: 'parts.entity.companyCode',
            })}
          />
        </Col>
      )}

      <Col xs={24} md={12} xl={6}>
        <Input
          value={queryParams?.description}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, description: value }))
          }
          placeholder={intl.formatMessage({ id: 'parts.entity.description' })}
        />
      </Col>
    </Row>
  );
}
